import React from "react";
import Navbar from "./Navbar";
import Products from "./Products";

function Home() {
  return (
    <>
      <Navbar />
      <Products />
    </>
  );
}

export default Home;
